import type { GameState } from "./GameState";
import { bus } from "../core/EventBus";

const CAPACITY = 12;

/** Inventario deliberadamente limitado (punto 16). */
export class InventoryManager {
  constructor(private state: GameState) {}

  has(itemId: string): boolean {
    return this.state.inventory.includes(itemId);
  }

  list(): readonly string[] {
    return this.state.inventory;
  }

  isFull(): boolean {
    return this.state.inventory.length >= CAPACITY;
  }

  /** Devuelve true si lo recoge. Las evidencias del misterio nunca se descartan. */
  add(itemId: string): boolean {
    if (this.has(itemId)) return false;
    const isEvidence = /^tarjeta/.test(itemId);
    if (this.isFull() && !isEvidence) return false;
    this.state.inventory.push(itemId);
    this.state.persist();
    bus.emit("ITEM_PICKED", { itemId });
    return true;
  }

  remove(itemId: string): void {
    const i = this.state.inventory.indexOf(itemId);
    if (i >= 0) {
      this.state.inventory.splice(i, 1);
      this.state.persist();
    }
  }
}
